import React from "react";
import { Helmet } from "react-helmet-async";

interface WeddingMetaProps {
	title: string;
	description: string;
	image: string;
	url: string;
}

const WeddingMeta = ({ title, description, image, url }: WeddingMetaProps) => {
	return (
		<Helmet>
			{/* General */}
			<title>{title}</title>
			<meta name="description" content={description} />

			{/* English Keywords */}
			<meta
				name="keywords"
				content="online wedding invitation, digital wedding card, wedding RSVP, wedding website, personalized invitations, RSVP online, save the date"
			/>

			{/* Arabic Keywords */}
			<meta
				name="keywords"
				content="دعوة زفاف إلكترونية, بطاقة زفاف رقمية, دعوة زفاف عبر الإنترنت, حفظ التاريخ الرقمي, RSVP زفاف, موقع زفاف"
			/>

			{/* Open Graph / Facebook / WhatsApp */}
			<meta property="og:type" content="website" />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={image} />
			<meta property="og:url" content={url} />
			<meta property="fb:app_id" content={process.env.FACEBOOK_APP_ID || ""} />

			{/* Twitter */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />
		</Helmet>
	);
};

export default WeddingMeta;
